<template>
    <div class="row">
        <div class="col-lg-3 col-sm-6"
            v-for="category in topCategories" :key="category.id"
        >
            <div class="item">
                <v-lazy-image :src="category.image_url"
                              :alt="category.name"
                ></v-lazy-image>
<!--                <img :src="category.image_url" alt="category">-->
                <h3>{{ category.name }}</h3>
                <a :href="category.detail_url" class="button sm">
                    {{ category.products_count }} {{ getCorrectText(category.products_count) }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import VLazyImage from "v-lazy-image";

    export default {
        props: {
            categories: {
                required: true,
                type: Array
            }
        },

        data() {
            return {
                topCategories: []
            }
        },

        created() {

            axios.post('/api/frontend/top-categories', {
                sites: this.services
            }).then( response =>  this.topCategories = response.data.categories)
                .catch( error => console.error(error) );
        },

        methods: {
            getCorrectText(count) {
                if ( count === 1 ) return 'produkt';
                else if ( count === 2 || count === 3 || count === 4 ) return 'produkty';
                else return 'produktov';
            }
        },

        components: {
            VLazyImage
        }
    }
</script>
